module.exports = __webpack_public_path__ + "img/TS-Logo-2-wh.2a5ec035.svg";